import React, { Component } from "react";
import Content from "../../content/Content";
import { Paths } from "../../constants/UrlConstants";
import Store from "../../content/Store";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setSelectedPolicy } from "../../actions/policy/policyActions";
import MemberHelper from "../../helpers/MemberHelper";
import PolicyDescription from "../shared/PolicyDescription";
import { handleKeyPress } from "../../helpers/KeyPressHelper";
import { BrandTypes, Layouts } from "../../constants/Constants";

class SinglePolicy extends Component {
  render() {
    const isSelectedPolicyAlreadySelected =
      this.props.selectedPolicy === this.props.currentPolicy;
    const isDisabledInHOLAxaHealth =
      this.props.selectedPolicy.Brand === BrandTypes.AXA &&
      this.props.layout === Layouts.HOL;
    const disabledClass = `${
      this.props.selectedPolicy.HasPolicyLapsedForMoreThan3Years ||
      isDisabledInHOLAxaHealth
        ? "disabled"
        : ""
    }`;

    let policyContent = null;
    if (this.props.selectedPolicy.HasPolicyLapsedForMoreThan3Years) {
      policyContent = (
        <div className="content contentDisabled">
          <br />
          <Content name={Store.PolicyLaspedGreaterThan3Years}></Content>
        </div>
      );
    } else if (isDisabledInHOLAxaHealth) {
      policyContent = (
        <div className="content contentDisabled">
          <br />
          <Content
            name={Store.ChooseYourPlan.MovedToAxaHealthMessage}
          ></Content>
        </div>
      );
    }

    return (
      <div
        id={this.props.selectedPolicy.MembershipNumber}
        tabIndex="0"
        className={`topDropItem bottom-border-dash ${
          isSelectedPolicyAlreadySelected ? "current" : ""
        } ${disabledClass}`}
        onClick={(e) => {
          if (
            !this.props.selectedPolicy.HasPolicyLapsedForMoreThan3Years &&
            !isDisabledInHOLAxaHealth
          ) {
            this.props.setSelectedPolicy(this.props.selectedPolicy);
            this.props.closeModal && this.props.closeModal();
            this.props.history.push(Paths.HomeRoot);
          }
        }}
        onKeyPress={(e) => {
          handleKeyPress(e, () => {
            if (
              !this.props.selectedPolicy.HasPolicyLapsedForMoreThan3Years &&
              !isDisabledInHOLAxaHealth
            ) {
              this.props.setSelectedPolicy(this.props.selectedPolicy);
              this.props.closeModal && this.props.closeModal();
            }
          });
        }}
      >
        {isSelectedPolicyAlreadySelected ? (
          <i className="topDropIcon icon-check" />
        ) : null}

        <div className="topDropContentsFlexBox">
          <div className="title">
            <PolicyDescription
              productType={this.props.selectedPolicy.ProductType}
              isSME={this.props.isSME}
              policyDescription={<Content name={Store.Policy} />}
            />
          </div>
          <div
            className={`content ${
              this.props.selectedPolicy.HasPolicyLapsedForMoreThan3Years ||
              isDisabledInHOLAxaHealth
                ? "contentDisabled"
                : "contentEnabled"
            }`}
          >
            {Store.GeneralPages.MembershipNumber}:{" "}
            {this.props.selectedPolicy.MembershipNumber}
          </div>
          {policyContent}
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (
  { policyReducer = {}, layoutReducer = {} },
  ownProps
) => {
  return {
    policies:
      policyReducer.policyDetails && policyReducer.policyDetails.Policies,
    fullname:
      policyReducer.selectedPolicy &&
      MemberHelper.getCurrentLoggedInMemberFromPolicy(
        policyReducer.selectedPolicy
      ).FullName,
    CurrentPolicy: policyReducer.selectedPolicy,
    layout: layoutReducer.layout,
    ...ownProps
  };
};

export const HomeAccount = function ({
  setSelectedPolicy,
  fullname,
  layout,
  closeModal,
  isOpen,
  IsSME,
  history,
  policies = [],
  CurrentPolicy = {}
}) {
  return (
    <React.Fragment>
      {isOpen ? (
        <div
          className="topDrop dropdown-menu align-left show"
          aria-labelledby="navbarDropdown"
        >
          <div className="topDrop topDropHeader">
            <div className="topDropUserName fontStlyingLight">{fullname}</div>
            <div className="topDropPlans capitalize fontStyling">
              {policies.length} available <Content name={Store.MultiPolicies} />
            </div>
          </div>

          {policies.map((policy) => {
            return (
              <SinglePolicy
                key={policy.MembershipNumber}
                selectedPolicy={policy}
                currentPolicy={CurrentPolicy}
                layout={layout}
                setSelectedPolicy={setSelectedPolicy}
                closeModal={closeModal}
                isSME={IsSME}
                history={history}
              />
            );
          })}

          <div className="topDropFooter">
            <Link to={Paths.MyProfile} onClick={closeModal}>
              <Content name={Store.Header.MyProfileLink} />
            </Link>
          </div>
          <div className="axa-hamburger-menu-mask" />
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default withRouter(
  connect(mapStateToProps, { setSelectedPolicy })(HomeAccount)
);
